import React from "react"
import { AddedIcon } from "@/components/PartsViewer/v2/icon.js"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"

import PropTypes from "prop-types"

const ButtonLabel = props => {
  const { t } = useTranslation("common")
  const { addedText } = getTranslations(t)
  const { cartQuantity, list = false } = props

  if (list) {
    return (
      <p>
        <AddedIcon />
        <span className="add-label">({cartQuantity})</span>
      </p>
    )
  }
  return (
    <>
      <AddedIcon />
      <span className="added-label">
        {addedText} ({cartQuantity})
      </span>
    </>
  )
}

ButtonLabel.propTypes = {
  cartQuantity: PropTypes.string.isRequired,
  list: PropTypes.bool.isRequired,
}

export default ButtonLabel
